import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from "react-query";
import { ApiClient } from "../../apiUtils";
import {
  ResponseError,
  SubscriptionSchema,
  SubscriptionsViewsSubscriptionsActiveSubscriptionsRequest,
  SubscriptionsViewsSubscriptionsBillingPortalRequest,
  SubscriptionsViewsSubscriptionsCheckoutSessionRequest,
} from "../../api-client";

export const useActiveSubscription = (
  query: SubscriptionsViewsSubscriptionsActiveSubscriptionsRequest,
): UseQueryResult<SubscriptionSchema> => {
  return useQuery({
    queryKey: [
      "activeSubscription",
      query.workspaceId || query.organizationId || query.workspaceSlug,
    ],
    queryFn: async ({ signal }) =>
      ApiClient.subscriptionsViewsSubscriptionsActiveSubscriptions(query, {
        signal,
      }),
  });
};

export const useSubscription = (
  subscriptionId: number,
): UseQueryResult<SubscriptionSchema> => {
  return useQuery({
    queryKey: ["subscription", subscriptionId],
    queryFn: async ({ signal }) =>
      ApiClient.subscriptionsViewsSubscriptionsGetSubscription(
        { subscriptionId },
        { signal },
      ),
  });
};

export const useCheckoutSessionMutation = (): UseMutationResult<
  string,
  ResponseError,
  SubscriptionsViewsSubscriptionsCheckoutSessionRequest,
  unknown
> => {
  return useMutation({
    mutationFn: async (
      query: SubscriptionsViewsSubscriptionsCheckoutSessionRequest,
    ) => ApiClient.subscriptionsViewsSubscriptionsCheckoutSession(query),
  });
};

export const useBillingPortalMutation = (): UseMutationResult<
  string,
  ResponseError,
  SubscriptionsViewsSubscriptionsBillingPortalRequest,
  unknown
> => {
  return useMutation({
    mutationFn: async (
      query: SubscriptionsViewsSubscriptionsBillingPortalRequest,
    ) => ApiClient.subscriptionsViewsSubscriptionsBillingPortal(query),
  });
};
